import {
    Award,
    BadgePercent,
    Bell,
    ChartColumn,
    CircleHelp,
    Code,
    CreditCard,
    FileText,
    House,
    Layers,
    Link2,
    LogOut,
    Mail,
    MessageCircleQuestion,
    Network,
    Package,
    Ruler,
    Send,
    ShoppingCart,
    Star,
    Store,
    Tag,
    Ticket,
    Truck,
    Undo2,
    UserRound,
    Users,
    type LucideIcon,
} from 'lucide-react';

import { cn } from '@platform/ui';

/**
 * The navigation's icons, by the name each menu entry declares (docs/10 §9,
 * Icons): Lucide at 20px, the colour of the label beside it, so an icon dims
 * with its row and takes the accent only on the active one.
 */
const icons: Record<string, LucideIcon> = {
    dashboard: House,
    notifications: Bell,
    products: Package,
    brands: Award,
    inventory: Layers,
    pricing: Tag,
    suppliers: Truck,
    orders: ShoppingCart,
    claims: Undo2,
    shipping: Send,
    customers: Users,
    questions: MessageCircleQuestion,
    invoices: FileText,
    channels: Link2,
    mapping: Network,
    finance: ChartColumn,
    storefront: Store,
    coupons: Ticket,
    promotions: BadgePercent,
    sizeGuides: Ruler,
    newsletter: Mail,
    account: UserRound,
    reviews: Star,
    support: CircleHelp,
    developer: Code,
    subscription: CreditCard,
    team: Users,
    signOut: LogOut,
};

/** One navigation icon by name; an unknown name renders nothing. */
export function NavIcon({ name, className }: { name: string; className?: string }) {
    const Icon = icons[name];
    if (!Icon) return null;
    return <Icon aria-hidden="true" className={cn('size-5 shrink-0', className)} />;
}
